export type ConsentModalView = "consent" | "refuse" | "exit";

export function getConsentModalTitle(
    view: ConsentModalView,
    titles: { consentHeader: string; refusalExitTitle: string }
): string {
    return view === "exit" ? titles.refusalExitTitle : titles.consentHeader;
}
